// extracted by mini-css-extract-plugin
export default {"box":"User_box__kMU5l"};